// 편집 카드(contentEditable) HTML 정리 — 브라우저가 붙인 배경색만 걷어낸다(PORTAL-15540).
//
// 보고서의 AI 카드(종합의견 파랑·특이사항 주황)는 담당자가 직접 고칠 수 있다. 문구를 지우거나 이어
// 붙이면 Chrome 이 카드의 **계산된 배경색**(예: rgba(230, 92, 0, 0.04))을 글자마다 inline style 로
// 박아 넣는다. 그대로 결재문서(흰 바탕)에 실리면 문구 전체에 음영이 깔린다(임은주 2026-10-30 신고).
//
// 정산 쪽 sanitizeRich 는 span 을 통째로 벗겨 굵기(font-weight)까지 잃으므로 쓰지 않는다 —
// 여기서는 background · background-color 선언만 지우고 나머지 마크업은 건드리지 않는다.
// 멱등 · 문자열 처리라 서버(SSR)·브라우저 어디서나 같은 결과다.

const BACKGROUND_DECL = /^\s*background(-color)?\s*:/i;

function cleanStyle(style: string): string {
  return style
    .split(';')
    .filter((decl) => decl.trim() !== '' && !BACKGROUND_DECL.test(decl))
    .map((decl) => decl.trim())
    .join('; ');
}

/** 입력과 같은 타입을 돌려준다(null·undefined 는 그대로). */
export function stripEditorBackground<T extends string | null | undefined>(
  html: T,
): T {
  if (!html || !/background/i.test(html)) return html;
  return (html as string).replace(
    /\sstyle\s*=\s*("([^"]*)"|'([^']*)')/gi,
    (_m, _q, dq: string | undefined, sq: string | undefined) => {
      const quote = dq !== undefined ? '"' : "'";
      const cleaned = cleanStyle(dq ?? sq ?? '');
      return cleaned ? ` style=${quote}${cleaned};${quote}` : '';
    },
  ) as T;
}
